export default __webpack_public_path__ + "static/landscapes-spread-4f6327608d0384293ee547c4ec740191.jpg";